import { createContext } from 'react';
import type { UseFormRes } from './useForm';
import type { FormItemProps } from './item';

export type FormContextType = UseFormRes;

const FormContext = createContext<FormContextType & Pick<FormItemProps, 'labelProps' | 'requiredMark'>>({
  getFieldsValue: () => ({}),
  getFieldValue: () => {},
  setFieldsValue:  () => {},
  getFieldsError:  () => ({}),
  validateFields: async () => ({}),
  resetFields: () => {},
  setFieldsValidatorRules: () => {},
  validatorRules: {},
  removeFieldErrors:  () => {},
  setFieldsError:  () => {},
  requiredMark: false
});

export default FormContext;